import React, { Component } from 'react';
import NotificationsComponent from "./notifications-component";
import {connect} from "react-redux";
import {hover, removeNotificationRequest, unhover} from "./notifications-action-creators";



class NotificationsContainer extends Component {

  render() {
    return (
      <NotificationsComponent
        {...this.props}
      />
    )
  }
}


const mapStateToProps = state => ({
  notifications: state.notifications.notifications
});

const mapDispatchToProps = dispatch => ({
  removeNotification: id => dispatch(removeNotificationRequest(id)),
  hover: id => dispatch(hover(id)),
  unhover: id => dispatch(unhover(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsContainer);


// WEBPACK FOOTER //
// ./src/modules/notifications/notifications-container.js